import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Grid,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TableHeader } from 'pages/calculator/MediaPlanning/common/BudgetTable/interfaces';
import {
  CalculatedTVBudget,
  OOHConfig,
  ResponseCopy,
  TVConfig,
} from '../../../../../../../../../../store/planStore';
import BudgetTableRow from '../BudgetTableRow/BudgetTableRow';
import { BudgetTableContainer } from '../styles';
import TVReachRow from './TVReachRow/TVReachRow';
import TotalTVRow from './TotalTVRow/TotalTVRow';
import TVOptionalFooter from '../../TVOptionalFooter/TVOptionalFooter';

interface OfflineBudgetTableProps {
  data: CalculatedTVBudget;
  formData: {
    tv?: TVConfig;
    ooh?: OOHConfig;
  };
}

function EstimatedTVBudgetTable({ data, formData }: OfflineBudgetTableProps) {
  const { t } = useTranslation();

  const tableHeaders: TableHeader[] = [
    { key: 'mediaPlanning.touchpoint', align: 'left', width: '200px' },
    { key: 'mediaPlanning.copy', align: 'left', width: '25%' },
    { key: 'mediaPlanning.weeks', align: 'right', width: '25%' },
    { key: 'mediaPlanning.grp', align: 'center', width: '15%' },
    { key: 'mediaPlanning.split', align: 'center', width: '15%' },
    {
      key: `${t('mediaPlanning.budget')} (${data.techCost?.currency ?? 'PLN'})`,
      align: 'right',
      width: '15%',
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography
          variant="body2"
          sx={{
            pl: '16px',
            pb: '12px',
            fontWeight: 700,
            textTransform: 'uppercase',
          }}
        >
          {t('mediaPlanning.estimatedTv')}
        </Typography>
        <BudgetTableContainer>
          <Table sx={{ width: '100%', tableLayout: 'fixed' }}>
            <TableHead>
              <TableRow>
                {tableHeaders.map((header) => (
                  <TableCell
                    key={header.key}
                    align={header.align}
                    sx={{ width: header?.width || 'auto' }}
                  >
                    <Typography
                      variant="caption"
                      textTransform="uppercase"
                      fontWeight={600}
                    >
                      {t(header.key)}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.copies?.map((row: ResponseCopy) => (
                <BudgetTableRow
                  key={row.name}
                  rowData={row}
                  touchpoint={data.touchpointName}
                />
              ))}
              <TVReachRow data={data} />
              <TotalTVRow data={data} />
            </TableBody>
            {formData?.ooh?.isAvailable ||
              (formData?.ooh?.calculatedBudget?.data.length === 0 && (
                <TVOptionalFooter rows={[]} />
              ))}
          </Table>
        </BudgetTableContainer>
      </Grid>
    </Grid>
  );
}

export default EstimatedTVBudgetTable;
